import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import axios from 'axios';
import { API } from '../../App';
import { toast } from 'sonner';

const SymptomCheckerTab = ({ user, setResult }) => {
  const [symptoms, setSymptoms] = useState('');
  const [duration, setDuration] = useState('');
  const [severity, setSeverity] = useState('moderate');
  const [loading, setLoading] = useState(false);

  const handleSymptomCheck = async () => {
    if (!symptoms) { toast.error('Please describe your symptoms'); return; }
    setLoading(true);
    try {
      const response = await axios.post(`${API}/symptom-checker`, {
        symptoms, duration: duration || 'recent', severity, age: user.age || 30, gender: user.gender || 'unspecified'
      });
      setResult({ type: 'symptom', data: response.data });
      toast.success('Symptom analysis complete!');
    } catch (error) {
      toast.error('Failed to check symptoms: ' + (error.response?.data?.detail || error.message));
    } finally { setLoading(false); }
  };

  return (
    <Card className="p-6" data-testid="symptom-checker-tab">
      <h2 className="text-2xl font-bold text-blue-600 mb-6">AI Symptom Checker</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Describe your symptoms *</label>
          <textarea value={symptoms} onChange={(e) => setSymptoms(e.target.value)} placeholder="e.g., headache, fever, body ache..." className="w-full px-3 py-2 border rounded-md" rows="3" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Duration</label>
            <select value={duration} onChange={(e) => setDuration(e.target.value)} className="w-full px-3 py-2 border rounded-md">
              <option value="">Select...</option>
              <option value="hours">Few hours</option>
              <option value="1-2 days">1-2 days</option>
              <option value="3-7 days">3-7 days</option>
              <option value="1-2 weeks">1-2 weeks</option>
              <option value="more than 2 weeks">More than 2 weeks</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Severity</label>
            <select value={severity} onChange={(e) => setSeverity(e.target.value)} className="w-full px-3 py-2 border rounded-md">
              <option value="mild">Mild</option>
              <option value="moderate">Moderate</option>
              <option value="severe">Severe</option>
            </select>
          </div>
        </div>
        <Button onClick={handleSymptomCheck} disabled={loading || !symptoms} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="check-symptoms-btn">
          {loading ? 'Analyzing...' : 'Check Symptoms'}
        </Button>
      </div>
    </Card>
  );
};

export default SymptomCheckerTab;
